/**
 * @constant
 * A key for storing combined favorites and the order of the folders in localStorage
 */
export const CLIENT_CONFIGURATION_COMBINED_FAVORITES_KEY = "CombinedFavoritesOrder";
